// 📁 org-tree-manager/src/hooks/useTenant.js

import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function useTenant() {
  const { tenantId } = useParams();
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  // Simulated tenant metadata — replace with real API call later
  const tenantMap = {
    acme: {
      name: 'Acme Corp',
      logo: '/src/images/tenants/acme-logo.png',
      color: '#1E40AF'
    },
    zenith: {
      name: 'Zenith Group',
      logo: '/src/images/tenants/zenith-logo.png',
      color: '#047857'
    },
    orbit: {
      name: 'Orbit Systems',
      logo: '/src/images/tenants/orbit-logo.png',
      color: '#DC2626'
    }
  };

  useEffect(() => {
    // Simulate async fetch
    const fetchTenant = async () => {
      setLoading(true);

      // Replace with real API call later
      const metadata = tenantMap[tenantId];

      setTenant(
        metadata || {
          name: 'Unknown Tenant',
          logo: '/src/images/default-logo.png',
          color: '#6B7280'
        }
      );

      setLoading(false);
    };

    fetchTenant();
  }, [tenantId]);

  return { tenantId, tenant, loading };
}
